
// src/components/about/Biography.jsx
import React from 'react';
import aboutImage from '../../assets/images/aboutimage.jpg' 

const Biography = () => {
  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-6">
      <div className="flex flex-col md:flex-row md:space-x-6 mb-6">
        <div className="md:w-1/3 mb-4 md:mb-0">
          <img 
            src={aboutImage}
            alt="Esbjörn Falk"
            className="w-full h-auto rounded-lg shadow"
          />
        </div>
        <div className="md:w-2/3">
          <h2 className="text-2xl font-bold text-gray-100 mb-4">The Composer</h2>
        <p className="text-gray-300 mb-4">
        Independent, classically trained violinist and composer with over 20 years of
professional experience in Scandinavian symphony orchestras. Transitioned to full-
time classical composition in recent years, focusing primarily on works for violin, and
on chamber ensembles. Passionate about interdisciplinary collaborations with dance
and visual arts.        </p>


        </div>
      </div>
    

      <div className="mt-8">
      <h2 className="text-2xl font-bold text-gray-100 mb-4">Professional Experience</h2>
  
  <div className="mb-6">
    <h4 className="text-lg font-medium text-gray-200 mb-1">Composer</h4>
    <p className="text-gray-400 mb-2">2020–Present</p>
    <p className="text-gray-300 mb-2">
      Composing and producing original music for solo violin, string quartet, piano, and
      other chamber ensembles.
    </p>
    <p className="text-gray-300 mb-2">
      Collaborating with dancers and visual artists for multimedia performances (e.g.,
      premiered with live dance improvisation).
    </p>
    <p className="text-gray-300 mb-2">
      Self-recording and distributing compositions via digital platforms.
    </p>
  </div>
  
  <div className="mb-6">
    <h4 className="text-lg font-medium text-gray-200 mb-1">Violinist | Scandinavian Symphony Orchestras</h4>
    <p className="text-gray-400 mb-2">2000–2020</p>
    <p className="text-gray-300 mb-2">
      Malmö Symphony Orchestra: Long term contracts, 1991-95.
    </p>
    <p className="text-gray-300 mb-2">
      Norrköping Symphony Orchestra: long-term contracts, 1997-2007.
    </p>
    <p className="text-gray-300 mb-2">
      Played with Gothenburg Symphony Orchestra, Gävle Symphony Orchestra, Umeå
      Symphony Orchestra, Swedish Chamber Orchestra, Stockholm Philharmonic, Swedish
      Radio Symphony Orchestra, and Copenhagen's Sjaelland Symphony Orchestra.
    </p>
  </div>
  
  <div className="mb-6">
    <h4 className="text-lg font-medium text-gray-200 mb-1">Violin Instructor</h4>
    <p className="text-gray-400 mb-2">2005–2019</p>
    <p className="text-gray-300 mb-2">
      Taught violin technique and repertoire to students of varying skill levels.
    </p>
  </div>
</div>

<div className="mt-8">
<h2 className="text-2xl font-bold text-gray-100 mb-4">Education</h2>
  
  <div className="mb-6">
    <h4 className="text-lg font-medium text-gray-200 mb-1">Malmö Academy of Music</h4>
    <p className="text-gray-300 mb-2">
      Bachelor of Music in Violin Performance, 1991.
    </p>
  </div>
</div>
    
    </div>

    
  );
};

export default Biography;